//封装接口使用
import _UseAxios from './Axe'
import { Admin } from '@/assets/api/api'

//高级检索学科接口
export const getMMDL = (data) => {
  return _UseAxios.get(Admin.getMMDL, data)
}
//高级检索学科接口
export const getXKLX = (data) => {
  return _UseAxios.get(Admin.getXKLX, data)
}
//网站访问量接口
export const getAllSum = (data) => {
  return _UseAxios.get(Admin.getAllSum, data)
}
//首页广告
export const GetFloatingAds = (data) => {
  return _UseAxios.get(Admin.GetFloatingAds, data)
}
//阅读/下载量接口
export const getOAViewTJ = (data) => {
  return _UseAxios.get(Admin.getOAViewTJ, data)
}
//高级检索栏目领域是否显示
export const getSFXS = (data) => {
  return _UseAxios.get(Admin.getSFXS, data)
}
//年度区间接口
export const postNDCJ = (data) => {
  return _UseAxios.get(Admin.postNDCJ, data)
}
//高级检索栏目接口
export const getLM = (data) => {
  return _UseAxios.get(Admin.getLM, data)
}
//注册
export const postRegist = (data) => {
  return _UseAxios.post(Admin.postRegist, data)
}
//发送验证码
export const getRegSendCode = (data) => {
  return _UseAxios.get(Admin.getRegSendCode, data)
}
//密码找回
export const getForgetPassword = (data) => {
  return _UseAxios.post(Admin.getForgetPassword, data)
}
//判断手机号邮箱是否注册过
export const getRegDeteCt = (data) => {
  return _UseAxios.get(Admin.getRegDeteCt, data)
}
//页面初始化形成的验证码GUID
export const getVerificationcode = (data) => {
  return _UseAxios.get(Admin.getVerificationcode, data)
}
//登录
export const postLogin = (data) => {
  return _UseAxios.post(Admin.postLogin, data)
}
//文献导出列表获取
export const getWZDC = (data) => {
  return _UseAxios.get(Admin.getWZDC, data)
}
//
export const getDCJK = (data) => {
  return _UseAxios.get(Admin.getDCJK, data)
}
//文章列表（栏目/学科/推荐/预出版/排行）《已完》
export const getXZPH = (data) => {
  return _UseAxios.get(Admin.getXZPH, data)
}

//检索
export const postSearch = (data) => {
  return _UseAxios.post(Admin.postSearch, data)
}
//qq登录请求
export const postThirdRegister = (data) => {
  return _UseAxios.post(Admin.postThirdRegister, data)
}
//获取轮播图
export const getBannerList = (data) => {
  return _UseAxios.get(Admin.getBanner, data)
}
//
export const GetScriptPrePrintDetailed = (data) => {
  return _UseAxios.get(Admin.GetScriptPrePrintDetailed, data)
}
//期刊社动态/作者营地
export const getActor = (data) => {
  return _UseAxios.post(Admin.getActor, data)
}
//友情链接
export const postFirend = (data) => {
  return _UseAxios.post(Admin.postFirend, data)
}
//期刊简介
export const getHeader = (data) => {
  return _UseAxios.post(Admin.getHeader, data)
}
//首页-最新一期列表
export const getNewlist = (data) => {
  return _UseAxios.get(Admin.getNewlist, data)
}
//最新一期
export const getYear = (data) => {
  return _UseAxios.get(Admin.getYear, data)
}
//首页封面，封底，目次打开文件
export const OpenGUIDFile = (data) => {
  return _UseAxios.get(Admin.OpenGUIDFile, data)
}
export const OpenFilebyGuid = (data) => {
  return _UseAxios.get(Admin.OpenFilebyGuid, data)
}

export const OpenMessageFilebyGuid = (data) => {
  return _UseAxios.get(Admin.OpenMessageFilebyGuid, data)
}
// 下载pdf
// export const getPDF = (data) => {
//     return _UseAxios.down(Admin.getPDF, data);
// }
export const getPDF = (data) => {
  return _UseAxios.get(Admin.getPDF, data)
}
export const getPDFnew = (data) => {
  return _UseAxios.get(Admin.getPDFnew, data)
}
export const getPDFfile = (data) => {
  return _UseAxios.get(Admin.getPDFfile, data)
}
//html次数+1
export const getHtmlRead = (data) => {
  return _UseAxios.get(Admin.getHtmlRead, data)
}
//预初版
export const getList = (data) => {
  return _UseAxios.get(Admin.getList, data)
}

export const getLista = (data) => {
  return _UseAxios.get(Admin.getLista, data)
}
export const getListb = (data) => {
  return _UseAxios.get(Admin.getListb, data)
}

export const getXZCS = (data) => {
  return _UseAxios.get(Admin.getXZCS, data)
}
export const getLBXQ = (data) => {
  return _UseAxios.get(Admin.getLBXQ, data)
}

export const getdownXML = (data) => {
  return _UseAxios.get(Admin.getdownXML, data)
}
export const getPLLB = (data) => {
  return _UseAxios.post(Admin.getPLLB, data)
}

export const postMassage = (data) => {
  return _UseAxios.post(Admin.postMassage, data)
}

export const getgok = (data) => {
  return _UseAxios.get(Admin.getgok, data)
}

export const getSet = (data) => {
  return _UseAxios.post(Admin.getSet, data)
}

export const getLLCS = (data) => {
  return _UseAxios.get(Admin.getLLCS, data)
}

export const getdetailes = (id) => {
  return _UseAxios.get(Admin.getdetailes + '/' + id)
}
GetRss
export const GetRss = (data) => {
  return _UseAxios.get(Admin.GetRss, data)
}
GetRssycb
export const GetRssycb = (data) => {
  return _UseAxios.get(Admin.GetRssycb, data)
}
GetscriptRssycb
export const GetscriptRssycb = (data) => {
  return _UseAxios.get(Admin.GetscriptRssycb, data)
}

export const IssueDownLoad = (data) => {
  return _UseAxios.down(Admin.IssueDownLoad, data)
}
// 高级检索栏目领域是否显示
//     getSFXS: query => get('api/Common/GetSetItem', query),
//     //标题接口
//     getBT: query => post('api/Common/GETSetItems', query),
//     //头部导航栏
//     getHeader: query => post('api/Document/GetFixedItemBodys', query),
//     //文章浏览次数s
//     getLLCS: query => get('api/Web/IncView_Times', query),
//     //文档浏览次数
//     getWZCS: query => get('api/Document/Hits', query),
//     //下载次数
//     getXZCS: query => get('api/Web/IncArticleRead_Times', query),
//     //首页轮播接口
//     getBanner: query => get('api/Common/GetLoopItem', query),
//     //获取期数据接口
//     getYear: query => get('api/Web/GetIssue', query),
//     //获取导出接口
//     getDC: query => get('api/Web/GetIssue', query),
//     //获取首页列表预出版接口
//     getList: query => get('api/Common/GetSetItem', query),
//     getLista: query => get('api/Web/PreprintList', query),
//     getListb: query => get('api/Web/OAList', query),
//     //获取首页列表最新一期接口
//     getNewlist: query => get('api/Web/LastIssueList', query),
//     //过刊目录列表接口
//     getgok: query => get('api/Web/GetCatalog', query),
//     //高级检索学科领域接口
//     getXKLX: query => get('api/Common/GetDictList', query),
//     //下载PDF接口
//     getPDF: query => get('api/Web/ArticleDownLoad', query),
//     //高级检索栏目接口
//     getLM: query => get('api/Common/GetOAColumnDictList', query),
//     //投稿须知
//     getTGXZ: query => get('api/Document/GetFixedItemBodys', query),
//     //期封面、封底、目次下载接口
//     getGGM: query => get('api/Web/IssueDownLoad', query),
//     //期数据接口
//     getQSJ: query => get('api/Web/GetIssue', query),
//     //导出接口
//     getDCJK: query => get('api/Web/ExportFormat', query),
//     //首页总访问数
//     getFWZS: query => get('api/PageVisit/GetVisitCount', query),
//     //文章导出接口
//     getWZDC: query => get('api/Web/ExportList', query),
//     //下载排行接口
//     getXZPH: query => get('api/Web/OAList', query),
//     //列表详情接口
//     getLBXQ: query => get('api/Web/GetArticleDetailed', query),
//     //作者园地接口
//     getActor: query => post('api/Document/GetDocumentList', query),
//     //期刊社公告接口
//     getTELL: query => post('api/Document/GetDocumentList', query),
//     //文章检索接口
//     postSearch: query => post('api/Web/ArticleSearch', query),
//     //发表评论接口
//     postMassage: query => post('api/Comments/Item', query),
//     //评论列表接口
//     getPLLB: query => post('api/Comments/GetCommentList', query),
//     //友情链接接口
//     postFirend: query => post('api/Links/GetLinks', query),
//     //作者园地详情
//     postZZYD: query => get('api/Document/GetDetailed', query),
//     //年度区间接口
//     postNDCJ: query => get('api/common/GetPublishYearList', query),
//     // //bai
//     //发送验证码
//     getRegSendCode: query => get('api/CRCActiveRecord/Verificationcode', query),
//     //验证用户邮箱手机号是否已注册
//     getRegDeteCt: query => get('api/Account/IsRegistered', query),
//     //注册
//     postRegist: query => post('api/Account/Register', query),
// 	postThirdRegister1:query =>post('api/Account/ThirdRegister', query),
//     //登录
//     postLogin: query => post('api/Account/Login',query),
//     //页面初始化形成验证码以及GUID
//     getVerificationcode : query => get('api/Account/Verificationcode',query),
//     //忘记密码
//     getForgetPassword : query => post('api/Account/ForgetPassword',query),
//     aaaa : query => get('api/Document/GetDetailed',query),
export const getGetQrcode = (data) => {
  return _UseAxios.get(Admin.getGetQrcode, data)
}
export const getWeiXinLogin = (data) => {
  return _UseAxios.get(Admin.getWeiXinLogin, data)
}

export const GetToken = (data) => {
  return _UseAxios.get(Admin.GetToken, data)
}

export const EamilVerification = (data) => {
  return _UseAxios.get(Admin.EamilVerification, data)
}

export const NoLoginChangePassword = (data) => {
  return _UseAxios.post(Admin.NoLoginChangePassword, data)
}

export const GetYearIssueList = (data) => {
  return _UseAxios.get(Admin.GetYearIssueList, data)
}

export const GetArticleIDByNum = (data) => {
  return _UseAxios.get(Admin.GetArticleIDByNum, data)
}

export const PostSubscribe = (data) => {
  return _UseAxios.get(Admin.PostSubscribe, data)
}
export const UnSubscribe = (data) => {
  return _UseAxios.get(Admin.UnSubscribe, data)
}
export const GetIssueList = (data) => {
  return _UseAxios.post(Admin.GetIssueList, data)
}
